import { resourceExplorerDataSelector } from "./resourceExplorerDataSelector";
import { RootState } from "../../../../store";
import { ResourceExplorerGrouping } from "../../../../../services/cloudchipr.api";

export const resourceExplorerGroupingSelector = (
  state: RootState,
): ResourceExplorerGrouping => {
  const data = resourceExplorerDataSelector(state);

  return data?.grouping ?? null;
};
